import { render, staticRenderFns } from "./PortionDetails.vue?vue&type=template&id=7b2a1eb6&"
import script from "./PortionDetails.vue?vue&type=script&lang=ts&"
export * from "./PortionDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports